import { render, staticRenderFns } from "./subjectItem.vue?vue&type=template&id=17cda67c&scoped=true&"
import script from "./subjectItem.vue?vue&type=script&lang=js&"
export * from "./subjectItem.vue?vue&type=script&lang=js&"
import style0 from "./subjectItem.vue?vue&type=style&index=0&id=17cda67c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cda67c",
  null
  
)

export default component.exports